import { render, staticRenderFns } from "./ActiveDialog.vue?vue&type=template&id=332d33a4&scoped=true&"
import script from "./ActiveDialog.vue?vue&type=script&lang=js&"
export * from "./ActiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d33a4",
  null
  
)

export default component.exports